// Custom hook for calendar and availability management
import { useState, useEffect } from 'react';
import moment from 'moment';

export const useCalendarAvailability = (spaceDetails, spaceBookings, selectedDate) => {
  const [availableSlots, setAvailableSlots] = useState([]);
  const [bookedSlots, setBookedSlots] = useState([]);

  useEffect(() => {
    if (spaceBookings.length > 0) {
      generateAvailableSlots(spaceBookings);
    }
  }, [selectedDate, spaceBookings, spaceDetails]);

  const generateAvailableSlots = (bookings) => {
    if (!spaceDetails?.events?.[0]?.chargings?.[0]) return;
    
    const operatingHours = {
      start: spaceDetails.operatingHours?.start || 9,
      end: spaceDetails.operatingHours?.end || 18
    };
    
    const minBookingHours = spaceDetails.events[0].chargings[0].minimumBookingHours || 1;
    const selectedDateStr = selectedDate.format('YYYY-MM-DD');
    const dayBookings = bookings.filter(booking => booking.date === selectedDateStr);
    
    const allSlots = [];
    const booked = [];
    
    for (let hour = operatingHours.start; hour < operatingHours.end; hour++) {
      const timeSlot = {
        time: `${hour.toString().padStart(2, '0')}:00`,
        hour: hour,
        available: true,
        canBookMinimum: hour + minBookingHours <= operatingHours.end
      };
      
      const isBooked = dayBookings.some(booking => {
        const startHour = parseInt(booking.startTime.split(':')[0]);
        const endHour = parseInt(booking.endTime.split(':')[0]);
        return hour >= startHour && hour < endHour;
      });
      
      if (isBooked) {
        timeSlot.available = false;
        const booking = dayBookings.find(booking => {
          const startHour = parseInt(booking.startTime.split(':')[0]);
          const endHour = parseInt(booking.endTime.split(':')[0]);
          return hour >= startHour && hour < endHour;
        });
        booked.push({ ...timeSlot, booking });
      } else {
        let hasEnoughTime = true;
        for (let checkHour = hour; checkHour < hour + minBookingHours; checkHour++) {
          if (checkHour >= operatingHours.end) {
            hasEnoughTime = false;
            break;
          }
          const isBlockedByBooking = dayBookings.some(booking => {
            const startHour = parseInt(booking.startTime.split(':')[0]);
            const endHour = parseInt(booking.endTime.split(':')[0]);
            return checkHour >= startHour && checkHour < endHour;
          });
          if (isBlockedByBooking) {
            hasEnoughTime = false;
            break;
          }
        }
        
        timeSlot.canBookMinimum = hasEnoughTime;
        allSlots.push(timeSlot);
      }
    }
    
    setAvailableSlots(allSlots);
    setBookedSlots(booked);
  };

  return {
    availableSlots,
    bookedSlots
  };
};
